import BucketApiRequest from "./BucketApiRequest";
import { GET_PRODUCT_LIST_URL } from "../ApiUrls";

export default class ProductApiRequest extends BucketApiRequest {
  getUrl = () => {
    return GET_PRODUCT_LIST_URL;
  };
}
